import { useEffect, useRef } from 'react';

/**
 * Remembers props, state, or any derived value, from a previous render.
 *
 * @param value {T} - The value you want to remember, will be returned in the next render.
 * @returns {T} - The value you provided in the previous render.
 */
const usePrevious = <T>(value: T) => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export default usePrevious;
